import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { ref, get } from 'firebase/database';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { 
    FaUserCircle, 
    FaSignOutAlt, 
    FaChevronDown, 
    FaBell, 
    FaUsers, 
    FaRegCircle,
    FaHome,
    FaChartBar,
    FaFileInvoice,
    FaUnlockAlt
} from 'react-icons/fa';

const Sidebar = () => {
    const [userData, setUserData] = useState(null);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                const snapshot = await get(ref(db, 'ekamwatapzp/users/' + user.uid));
                if (snapshot.exists()) {
                    setUserData(snapshot.val());
                }
            }
        });
        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        await auth.signOut();
        localStorage.removeItem('currentUser');
        navigate('/');
    };

    const checkActive = (item) => {
        if (!item) return false;
        if (item.path && location.pathname === item.path) return true;
        if (item.children) {
            return item.children.some(child => checkActive(child));
        }
        return false;
    };

    const menuItems = [
        { 
            name: "डॅशबोर्ड", 
            path: "/admin-dashboard", 
            icon: <FaHome size={14} />
        },
        {
            name: "सु.बे. अभियंता",
            icon: <FaUsers size={14} />,
            children: [
                { name: "नवीन सु. बे. अभियंत्याची यादी", path: "/admin/subhe-new-list" },
                { name: "सु. बे. लॉटरी यादी", path: "/admin/engineer-lottery-list" },
            ]
        },
        {
            name: "मजूर संस्था",
            icon: <FaUsers size={14} />,
            children: [
                { name: "नवीन मजूर संस्थाची यादी", path: "/admin/society-new-list" },
                { name: "मजूर संस्था लॉटरी यादी", path: "/admin/society-lottery-list" },
            ]
        },
        {
            name: "वर्कलिस्ट चलन",
            icon: <FaFileInvoice size={14} />,
            children: [
                { name: "सु.बे चलन", path: "/ceo/worklist-subhe-challan" },
                { name: "मजूर संस्था चलन", path: "/ceo/worklist-majur-challan" }
            ]
        },
        {
            name: "सर्व रिपोर्ट",
            icon: <FaChartBar size={14} />,
            children: [
                { 
                    name: "सु.बे. इंटरेस्टेड वर्क लिस्ट", 
                    children: [
                        { name: "इंटरेस्टेड वर्क लिस्ट", path: "/ceo/interested-work-list" },
                        { name: "तारखेनुसार लिस्ट", path: "/ceo/datewise-interested-work-list" }
                    ]
                },
                { 
                    name: "मजूर संस्था इंटरेस्टेड वर्क लिस्ट", 
                    children: [
                        { name: "इंटरेस्टेड वर्क लिस्ट", path: "/ceo/majur-interested-work-list" },
                        { name: "तारखेनुसार लिस्ट", path: "/ceo/majur-datewise-interested-work-list" }
                    ]
                },
                { 
                    name: "लॉटरी यादी", 
                    children: [
                        { name: "सु.बे. अभियंता लॉटरी यादी", path: "/addceo/draw-lottery-list" },
                        { name: "मजूर संस्था लॉटरी यादी", path: "/addceo/society-draw-lottery-list" }
                    ]
                },
                { 
                    name: "शिफारस पत्र", 
                    children: [
                        { name: "सु.बे. शिफारस पत्र", path: "/addceo/subhe-shifaras-patra" },
                        { name: "मजूर संस्था शिफारस पत्र", path: "/addceo/society-shifaras-patra" }
                    ]
                },
                { 
                    name: "वर्क ऑर्डर", 
                    children: [
                        { name: "सु.बे.वर्क ऑर्डर", path: "/addceo/subhe-work-order" },
                        { name: "मजूर संस्था वर्क ऑर्डर", path: "/addceo/society-work-order" }
                    ]
                },
                { 
                    name: "लॉटरी कामवाटप रिपोर्ट", 
                    children: [
                        { name: "सु.बे.रिपोर्ट", path: "/addceo/subhe-kamwatap" },
                        { name: "मजूर संस्था रिपोर्ट", path: "/addceo/society-kamwatap" }
                    ]
                },
                { 
                    name: "शिफारस करावयाची यादी", 
                    children: [
                        { name: "सु.बे.यादी", path: "/addceo/subhe-shifaras-list" },
                        { name: "मजूर संस्था यादी", path: "/accountant/society-payment-list" }
                    ]
                },
                { 
                    name: "पेमेंट हिस्ट्री यादी", 
                    children: [
                        { name: "सु.बे.यादी", path: "/addceo/subhe-payment-list" },
                        { name: "मजूर संस्था यादी", path: "/addceo/society-payment-list" }
                    ]
                },
                { 
                    name: "कामवाटप पेमेंट डिटेल्स यादी", 
                    children: [
                        { name: "सु.बे. फंड ट्रान्स्फर यादी", path: "/accountant/subhe-fund-transfer-list" },
                        { name: "सु.बे. कामवाटप पेमेंट डिटेल्स यादी", path: "/accountant/subhe-payment-details" },
                        { name: "मजूर संस्था फंड ट्रान्स्फर यादी", path: "/accountant/society-fund-transfer-list" },
                        { name: "मजूर संस्था कामवाटप पेमेंट डिटेल्स यादी", path: "/accountant/society-payment-details" }
                    ]
                },
            ]
        },
        {
            name: "लिमिट एक्सपांड",
            icon: <FaUnlockAlt size={14} />,
            children: [
                { name: "अपडेट स्थिती", path: "/addceo/limit-expand-status" }
            ]
        }
    ];

    return (
        <header className="sticky top-0 z-[100] w-full shadow-lg">
            {/* Top Row: Branding and User Profile */}
            <div className="bg-[#f6f3ee] border-b border-gray-200/50 px-6 py-2 flex items-center justify-between h-14">
                <div className="flex-1 hidden xl:block"></div>

                {/* Center Title */}
                <div className="flex-[2] flex justify-center items-center">
                    <h1 className="text-[15px] md:text-xl font-extrabold text-black tracking-tight font-sans uppercase text-center whitespace-nowrap">
                        ZILLA PARISHAD SANGLI - (ADMIN DASHBOARD)
                    </h1>
                </div>

                <div className="flex-1 flex items-center justify-end gap-6">
                    <button className="text-gray-500 hover:text-emerald-600 transition-colors">
                        <FaBell size={20} />
                    </button>
                    
                    <div className="relative">
                        <div 
                            className="flex items-center gap-3 cursor-pointer group"
                            onClick={() => setIsProfileOpen(!isProfileOpen)}
                        >
                            <div className="text-right hidden sm:block">
                                <p className="text-sm font-bold text-gray-800 leading-none">{userData?.name || 'Admin User'}</p>
                                <p className="text-[11px] text-gray-500 font-medium mt-1 uppercase tracking-wider">{userData?.role || 'Admin'}</p>
                            </div>
                            <div className="relative">
                                <FaUserCircle size={36} className="text-gray-400 group-hover:text-emerald-600 transition-colors" />
                                <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-[#f6f3ee] rounded-full"></div>
                            </div>
                        </div>

                        {/* Profile Dropdown */}
                        {isProfileOpen && (
                            <>
                                <div className="fixed inset-0 z-40" onClick={() => setIsProfileOpen(false)}></div>
                                <div className="absolute right-0 mt-3 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 animate-in fade-in slide-in-from-top-2 duration-200">
                                    <div className="p-4 bg-gray-50/50 border-b border-gray-100">
                                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]">Account Management</p>
                                    </div>
                                    <div className="p-2">
                                        <button 
                                            onClick={handleLogout}
                                            className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
                                        >
                                            <FaSignOutAlt size={14} />
                                            <span className="font-bold text-sm">लॉगआउट (Logout)</span>
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Bottom Row: Navigation Menu */}
            <div className="bg-[#085e53] px-4 flex items-center justify-center h-12 relative shadow-md z-10">
                {menuItems.map((item, idx) => (
                    <div 
                        key={idx} 
                        className="relative h-full group"
                    >
                        <div
                            onClick={() => item.path && navigate(item.path)}
                            className={`flex items-center gap-2 px-6 h-full cursor-pointer whitespace-nowrap transition-all duration-200 text-sm font-bold ${
                                checkActive(item)
                                ? 'bg-white/20 text-white shadow-inner' 
                                : 'text-emerald-50/90 hover:bg-white/10 hover:text-white'
                            }`}
                        >
                            {item.icon}
                            <span>{item.name}</span>
                            {item.children && (
                                <FaChevronDown size={10} className="ml-1 transition-transform duration-300 group-hover:rotate-180 opacity-70" />
                            )}
                        </div>

                        {/* Dropdown Menu Container */}
                        {item.children && (
                            <div className="absolute top-[calc(100%-1px)] left-0 hidden group-hover:block z-[110] pt-0">
                                <div className="min-w-[260px] bg-white shadow-2xl border border-gray-100 overflow-visible rounded-b-lg">
                                    {item.children.map((child, childIdx) => (
                                        <div key={childIdx} className="relative group/sub">
                                            {child.children ? (
                                                <>
                                                    <div className={`flex items-center justify-between px-5 py-3 text-sm cursor-pointer border-b border-gray-50 last:border-0 transition-colors ${
                                                        checkActive(child)
                                                        ? 'bg-emerald-50 text-emerald-600 font-bold'
                                                        : 'text-gray-600 hover:bg-emerald-50 hover:text-emerald-600'
                                                    }`}>
                                                        <div className="flex items-center">
                                                            <FaRegCircle size={8} className={`mr-3 shrink-0 ${checkActive(child) ? 'opacity-100' : 'opacity-40'}`} />
                                                            <span className="whitespace-nowrap">{child.name}</span>
                                                        </div>
                                                        <FaChevronDown size={8} className={`transition-transform ${checkActive(child) ? '-rotate-90' : '-rotate-90 opacity-50'}`} />
                                                    </div>
                                                    
                                                    {/* Sub-sub-menu (Side Flyout) */}
                                                    <div className={`absolute top-0 hidden group-hover/sub:block z-[120] ${idx >= menuItems.length - 2 ? 'right-full pr-0.5' : 'left-full pl-0.5'}`}>
                                                        <div className="min-w-[220px] bg-white shadow-2xl border border-gray-100 overflow-hidden rounded-lg">
                                                            {child.children.map((subChild, subIdx) => (
                                                                <Link
                                                                    key={subIdx}
                                                                    to={subChild.path}
                                                                    className={`flex items-center px-5 py-3 text-sm transition-colors border-b border-gray-50 last:border-0 ${
                                                                        location.pathname === subChild.path 
                                                                        ? 'bg-emerald-50 text-emerald-600 font-bold' 
                                                                        : 'text-gray-500 hover:bg-emerald-50 hover:text-emerald-600'
                                                                    }`}
                                                                >
                                                                    <FaRegCircle size={6} className={`mr-3 shrink-0 ${location.pathname === subChild.path ? 'opacity-100' : 'opacity-30'}`} />
                                                                    <span className="whitespace-nowrap">{subChild.name}</span>
                                                                </Link>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <Link
                                                    to={child.path}
                                                    className={`flex items-center px-5 py-3 text-sm transition-colors border-b border-gray-50 last:border-0 ${
                                                        location.pathname === child.path 
                                                        ? 'bg-emerald-50 text-emerald-600 font-bold' 
                                                        : 'text-gray-600 hover:bg-emerald-50 hover:text-emerald-600'
                                                    }`}
                                                >
                                                    <FaRegCircle size={8} className={`mr-3 shrink-0 ${location.pathname === child.path ? 'opacity-100' : 'opacity-40'}`} />
                                                    <span className="whitespace-nowrap">{child.name}</span>
                                                </Link>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </header>
    );
};

export default Sidebar;
